import { Tooltip } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components/macro';

export const DisabledLayer = styled.div`
  opacity: ${props => (props.disabled ? '0.4' : '1')};
  pointer-events: ${props => (props.disabled ? 'none' : 'all')};

  ${({ $customCSS }) => $customCSS}
`;

const Wrapper = styled.div`
  width: 100%;
`;

const Disabler = ({
  disabled,
  onDisabledClick,
  tooltipText = '',
  tooltipProps,
  children,
  containerCSS
}) => {
  return (
    <Tooltip title={disabled ? tooltipText : ''} {...tooltipProps}>
      <Wrapper onClick={disabled ? onDisabledClick : () => {}}>
        <DisabledLayer $customCSS={containerCSS} disabled={disabled}>
          {children}
        </DisabledLayer>
      </Wrapper>
    </Tooltip>
  );
};

export default Disabler;
